import React from "react";
import styles from './PlayListSeeAll.module.css';
import { useNavigate } from "react-router";

const PlayListSeeAll = ({ data }) => {
  const navigate = useNavigate();

  const handleClickPlayList = (playlistId) => {
    navigate(`/music/detail/playlist/${playlistId}`);
  }

  return (
    <div className={`${styles.grid_cols_custom} grid`}>
      {data.map((item, index) => (
        <div key={item.id} className="relative h-20"
          onClick={() => handleClickPlayList(item.id)}
        >
          <img
            src={item.image}
            alt=""
            className="rounded w-full h-full object-cover"
          />
        </div>
      ))}
    </div>
  );
};

export default PlayListSeeAll;
